<template>
  <div class="bottom">
      <div class="bottom-inner">
          <div class="brand">
              <div class="brand-badge"><img src="/logo.png" alt="Logo" class="brand-logo-img"></div>
              <div class="brand-name">青少年人工智能高水平创新人才培养 课程平台</div>
          </div>
          <div class="links">
              <span>Scratch 图形化编程</span>
              <span class="dot">·</span>
              <span>Python 人工智能</span>
              <span class="dot">·</span>
              <span>C++ 算法竞赛</span>
          </div>
          <div class="copyright">Copyright © 2025 青少年人工智能高水平创新人才培养工程版权所有 备案号：京ICP备2025132537号-2</div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        
      }
    },
    methods: {
     
    },
    created() {
     
    },
    mounted() {
      
    }
 }
</script>

<style  scoped>
.bottom {
    width: 100%;
    flex-shrink: 0;
    background: #FFFFFF;
    border-top: 1px solid var(--border-soft);
    padding: 16px 40px;
    box-sizing: border-box;
}
.bottom-inner {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    font-size: 12px;
    color: var(--text-sub);
    max-width: 100%;
}
.brand {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-self: start;
}
.brand-badge {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}
.brand-logo-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}
.brand-name {
    font-weight: 600;
    color: var(--text-main);
    letter-spacing: 1px;
    white-space: nowrap;
    font-size: 13px;
}
.links {
    display: flex;
    align-items: center;
    gap: 6px;
    letter-spacing: 0.5px;
    justify-self: center;
    white-space: nowrap;
}
.links .dot {
    color: var(--primary-light);
}
.copyright {
    letter-spacing: 1px;
    color: var(--text-light);
    justify-self: end;
    white-space: nowrap;
    font-size: 11px;
}
</style>
